export default "__VITE_ASSET__DcvoxTVM__"